import {
  Button,
  CircularProgress,
  DialogContent,
  Drawer,
  Input,
  Option,
  Select,
  selectClasses,
} from "@mui/joy";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../appConstants";
import { useEffect, useState } from "react";
import Joi from "joi";
import PaginationComponent from "../commonComponents/PaginationComponent";
import { debounce } from "lodash";
import axios from "axios";
import appError from "../../appError";
import ArchiveToggle from "./ArchiveToggle";
import MultiSelect from "../commonComponents/MultiSelect";
import toast from "react-hot-toast";

type AddKeywordProps = {
  targeting: string;
  bcg_type: string;
}
type Targeting = {
  targeting_id: string;
  targeting: string;
  bcg_type: string;
};
type FilterStateObj = {
  targeting: string;
  bcg_type: string;
  limit: number;
  page: number;
};
type Types = {
  keyword_id: string;
  keyword: string;
};

const KeywordList: React.FC = () => {
  const [archiveToggle, setArchiveToggle] = useState<boolean>(false);
  const [archiveId, setArchiveId] = useState<string>("");
  const [filterToggle, setFilterToggle] = useState<boolean>(false);
  const [addKeywordToggle, setAddKeywordToggle] = useState<boolean>(false);
  const [dataFetchingState, setDataFetchingState] = useState<string>("LOADING");
  const [totalRows, setTotalRows] = useState<number>(0);
  const [selectedBrandId, setSelectedBrandId] = useState<string>("");
  const [selectedPlatformId, setSelectedPlatformId] = useState<string>("");
  const [selectedSubDashboardId, setSelectedSubDashboardId] =
    useState<string>("");
  const [addKeyword, setAddKeyword] = useState<AddKeywordProps>({
    targeting: "",
    bcg_type: ""
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [archiveloading, setArchiveLoading] = useState<boolean>(false);
  const [targeting_arr, setTargeting_arr] = useState<Targeting[]>([]);
  const [filterState, setFilterState] = useState<FilterStateObj>({
    targeting: "",
    bcg_type: "", 
    limit: 10,
    page: 1,
  });
  const [types, setTypes] = useState<Types[]>([
    {
      keyword_id: "1",
      keyword: "Brand",
    },
    {
      keyword_id: "2",
      keyword: "Competition",
    },
    {
      keyword_id: "3",
      keyword: "Generic",
    },
  ]);
  let keywordList = types.map((k) => {
    return { id: k.keyword_id, label: k.keyword };
  });
  const [selectedKeywords, setSelectedKeywords] = useState<Set<string>>(
    new Set([])
  );

  const onChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let set = new Set(selectedKeywords);
    if (e.target.checked) {
      set.add(id);
    } else {
      if (set.has(id)) {
        set.delete(id);
      }
    }
    setSelectedKeywords(set);
  };

  const onClearFilterHandler = () => {
    setSelectedKeywords(new Set([]));
    setFilterState((prev) => ({ ...prev, ["bcg_type"]: "" }));
  };

  const bcg_typehandleDropdownChange = (event: any, value: any) => {
    setAddKeyword((prev) => {
      return {
        ...prev,
        bcg_type: value,
      };
    });
  };

  //--------------------Search Input-----------------------
  const [searchFileArray, setSearchFileArray] = useState<
    { targeting: string }[]
  >([]);
  const [searchtarget, setSearchUser] = useState<string>("");
  const [searchFocus, setSearchFocus] = useState(false);

  const onSearchKeywordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value?.trimStart()) {
      setSearchFocus(true);
    } else {
      setSearchFocus(false);
      setFilterState((prev) => ({
        ...prev,
        ["targeting"]: e.target.value?.trimStart(),
        page: 1,
        limit: 10
      }));
    }
    setSearchUser(e.target.value?.trimStart());
  };

  const onKeyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e?.key === "Enter") {
      setSearchFocus(false);
      setFilterState((prevState) => ({
        ...prevState,
        full_name: searchtarget,
        page: 1,
        limit: 10,
      }));
    }
  };
  const selectSearchName = (value: string) => {
    setSearchUser(value);
    setSearchFocus(false);
  };

  const onSearchButtonClick = () => {
    setSearchFocus(false);
    setFilterState((prev) => ({
      ...prev,
      ["targeting"]: searchtarget,
      page: 1,
      limit: 10
    }));
  };

  const fetchProductSearchData = debounce(async () => {
    const token = localStorage.getItem("token");
    (async () => {
      try {
        let api = `${BASE_URL}brand/targeting/suggestTargets?brand_id=${selectedBrandId}&platform_id=${selectedPlatformId}&sub_module_for_platform_id=${selectedSubDashboardId}&targeting_name=${searchtarget}`;
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const result = await axios.get(api, { headers });
        const { targeting_array } = result?.data?.data;
        setSearchFileArray(targeting_array);
      } catch (error) {
      } finally {
      }
    })();
  }, 500);

  useEffect(() => {
    if (searchtarget) {
      fetchProductSearchData.cancel();
      fetchProductSearchData();
    }
    return () => {
      fetchProductSearchData.cancel();
    };
  }, [searchtarget]);
  //--------------------Search Input----------------------------

  const archiveIdSave = (keyword_id: string) => {
    setArchiveToggle(true);
    setArchiveId(keyword_id);
  };
  const cancelArchiveHandler = () => {
    setArchiveToggle(false);
  };

  const onFilterHandler = () => {
    setFilterToggle(true);
  };

  const fetchkeywords = async (
    brand_Id: string,
    platform_Id: string,
    subDashboard_Id: string
  ) => {
    setDataFetchingState("LOADING");
    const token = localStorage.getItem("token");
    const { page, limit, targeting, bcg_type } = filterState;
    console.log(filterState);
    let api = `${BASE_URL}brand/targeting?brand_id=${brand_Id}&platform_id=${platform_Id}&sub_module_for_platform_id=${subDashboard_Id}&limit=${limit}&page=${page}`;
    if (targeting && bcg_type) {
      api = `${api}&targeting=${targeting}&bcg_type=${bcg_type}`;
    } else if (targeting) {
      api = `${api}&targeting=${targeting}`;
    } else if (bcg_type) {
      api = `${api}&bcg_type=${bcg_type}`;
    }
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.get(api, { headers });
      const { targeting_array, total_records } = result?.data?.data;
      setTargeting_arr(targeting_array);
      setTotalRows(total_records);
      if (targeting_array.length === 0) {
        setDataFetchingState("EMPTY");
      } else {
        setDataFetchingState("SUCCESS");
      }
    } catch (error) {
      appError(error);
    } finally {
    }
  };

  const onSaveFilterHandler = () => {
    setFilterToggle(false);
    const op: string = types
      .filter((k) => selectedKeywords.has(k.keyword_id)) // Filter by the selected IDs
      .map((k) => k.keyword.toUpperCase()) // Map to uppercase keywords
      .join(", ");
    setFilterState((prev) => ({ ...prev, ["bcg_type"]: op }));
  };

  const addkeywordapi = async (brand_Id: string, platform_Id: string, subDashboard_Id: string) => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const {targeting, bcg_type} = addKeyword;
    let api = `${BASE_URL}brand/targeting?brand_id=${brand_Id}&platform_id=${platform_Id}&sub_module_for_platform_id=${subDashboard_Id}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.post(api,{targeting, bcg_type}, { headers });
      const {message} = result?.data?.data;
      toast.success(message);
      setLoading(false);
    } catch (error) {
      appError(error);
    } finally {
    }
  }
  const saveAddKeywordHandler = () =>{
    const schema = Joi.object({
      targeting: Joi.string().required(),
      bcg_type: Joi.string().valid("BRAND","COMPETITION","GENERIC").required(),
    })
    const validate = schema.validate(addKeyword);
    if(validate.error){
      appError(validate?.error?.toString());
      return;
    }
    addkeywordapi(selectedBrandId,selectedPlatformId,selectedSubDashboardId);
    fetchkeywords(selectedBrandId,selectedPlatformId,selectedSubDashboardId);
    setAddKeyword({targeting: "", bcg_type:""});
    setAddKeywordToggle(false);
  }

  const archiveHandler = async() =>{
    setArchiveLoading(true);
    const token = localStorage.getItem("token");
    let api = `${BASE_URL}brand/targeting/${archiveId}?brand_id=${selectedBrandId}&platform_id=${selectedPlatformId}&sub_module_for_platform_id=${selectedSubDashboardId}`;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    try {
      const result = await axios.put(api, {status: "INACTIVE"}, { headers });
      const {message} = result?.data?.data;
      fetchkeywords(selectedBrandId,selectedPlatformId,selectedSubDashboardId);
      toast.success(message);
      setArchiveLoading(false);
      setArchiveToggle(false);
    } catch (error) {
      appError(error);
    } finally {
    }
  }

  useEffect(() => {
    if (selectedBrandId && selectedPlatformId && selectedSubDashboardId) {
      fetchkeywords(
        selectedBrandId,
        selectedPlatformId,
        selectedSubDashboardId
      );
    }
  }, [filterState.targeting, filterState.bcg_type, filterState.page, filterState.limit]);

  useEffect(() => {
    const { brand_id } = JSON.parse(localStorage.getItem("brand") as string);
    const { platform_id } = JSON.parse(
      localStorage.getItem("platform") as string
    );
    const sub_dashboard_id = JSON.parse(
      localStorage.getItem("sub-dashboard") as string
    );
    setSelectedBrandId(brand_id);
    setSelectedPlatformId(platform_id);
    setSelectedSubDashboardId(sub_dashboard_id);
    fetchkeywords(brand_id, platform_id, sub_dashboard_id);
  }, []);

  return (
    <>
      <div className="px-10 pt-6">
        <div
          className="flex flex-row justify-between items-center px-6"
          style={{
            height: 96,
            borderRadius: 8,
            backgroundColor: PRIMARY.P_Purple50,
          }}
        >
          <div>
            <div
              className="mb-1"
              style={{ fontSize: 16, fontWeight: 600, lineHeight: "24px" }}
            >
              Add New Keywords
            </div>
            <div
              style={{
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "18px",
                color: BLACK.B_40,
              }}
            >
              {" "}
              Add new keyword’s to your list to start analyzing its performance
              and relevance.
            </div>
          </div>

          <Button
            // loading={loading}
            onClick={() => setAddKeywordToggle(true)}
            startDecorator={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M9.16663 10.8333H4.99996C4.76385 10.8333 4.56593 10.7535 4.40621 10.5937C4.24649 10.434 4.16663 10.2361 4.16663 9.99999C4.16663 9.76388 4.24649 9.56596 4.40621 9.40624C4.56593 9.24652 4.76385 9.16666 4.99996 9.16666H9.16663V4.99999C9.16663 4.76388 9.24649 4.56596 9.40621 4.40624C9.56593 4.24652 9.76385 4.16666 9.99996 4.16666C10.2361 4.16666 10.434 4.24652 10.5937 4.40624C10.7534 4.56596 10.8333 4.76388 10.8333 4.99999V9.16666H15C15.2361 9.16666 15.434 9.24652 15.5937 9.40624C15.7534 9.56596 15.8333 9.76388 15.8333 9.99999C15.8333 10.2361 15.7534 10.434 15.5937 10.5937C15.434 10.7535 15.2361 10.8333 15 10.8333H10.8333V15C10.8333 15.2361 10.7534 15.434 10.5937 15.5937C10.434 15.7535 10.2361 15.8333 9.99996 15.8333C9.76385 15.8333 9.56593 15.7535 9.40621 15.5937C9.24649 15.434 9.16663 15.2361 9.16663 15V10.8333Z"
                  fill="white"
                />
              </svg>
            }
            sx={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "20px",
              height: "48px",
              width: "200px",
              backgroundColor: PRIMARY.P_BLue,
            }}
          >
            Add Keyword
          </Button>
        </div>

        <div className="flex mt-6 justify-between items-center self-stretch">
          {/**Search container */}
          <div className="flex items-center">
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                zIndex: 99,
                display: "flex",
                position: "relative",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Input
                onChange={onSearchKeywordChange}
                value={searchtarget}
                onKeyDown={onKeyDownHandler}
                placeholder="Search by Keyword"
                startDecorator={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M17.9421 17.0578L14.0304 13.1469C15.1642 11.7857 15.7295 10.0398 15.6089 8.27244C15.4882 6.50506 14.6908 4.85223 13.3825 3.65779C12.0743 2.46334 10.3559 1.81926 8.58486 1.85951C6.81382 1.89976 5.12647 2.62125 3.87383 3.87389C2.62118 5.12653 1.89969 6.81388 1.85944 8.58492C1.8192 10.356 2.46328 12.0744 3.65772 13.3826C4.85217 14.6909 6.50499 15.4883 8.27238 15.6089C10.0398 15.7296 11.7856 15.1642 13.1468 14.0305L17.0577 17.9422C17.1158 18.0003 17.1848 18.0463 17.2606 18.0777C17.3365 18.1092 17.4178 18.1253 17.4999 18.1253C17.5821 18.1253 17.6634 18.1092 17.7392 18.0777C17.8151 18.0463 17.8841 18.0003 17.9421 17.9422C18.0002 17.8841 18.0463 17.8152 18.0777 17.7393C18.1091 17.6634 18.1253 17.5821 18.1253 17.5C18.1253 17.4179 18.1091 17.3366 18.0777 17.2607C18.0463 17.1848 18.0002 17.1159 17.9421 17.0578ZM3.12493 8.75C3.12493 7.63748 3.45483 6.54994 4.07292 5.62491C4.691 4.69989 5.56951 3.97892 6.59734 3.55317C7.62517 3.12743 8.75617 3.01604 9.84732 3.23308C10.9385 3.45012 11.9407 3.98585 12.7274 4.77252C13.5141 5.55919 14.0498 6.56147 14.2669 7.65261C14.4839 8.74376 14.3725 9.87475 13.9468 10.9026C13.521 11.9304 12.8 12.8089 11.875 13.427C10.95 14.0451 9.86245 14.375 8.74993 14.375C7.2586 14.3733 5.82882 13.7802 4.77429 12.7256C3.71975 11.6711 3.12659 10.2413 3.12493 8.75Z"
                      fill="#1C1C1C"
                      fill-opacity="0.4"
                    />
                  </svg>
                }
                sx={{
                  width: "320px",
                  height: "40px",
                  "--Input-focusedThickness": "0px",
                  borderBottom: searchFocus ? "0px" : `1px solid ${BLACK.B_10}`,
                  borderTop: `1px solid ${BLACK.B_10}`,
                  borderLeft: `1px solid ${BLACK.B_10}`,
                  borderRight: `1px solid ${BLACK.B_10}`,
                  borderBottomRightRadius: searchFocus ? "0px" : "6px",
                  borderBottomLeftRadius: searchFocus ? "0px" : "6px",
                  backgroundColor: WHITE.W_100,
                  color: (searchtarget === "") ? BLACK.B_40 : BLACK.B_100,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  boxShadow: "none",
                }}
              />
              {searchFocus && (
                <div
                  style={{
                    position: "absolute",
                    top: 40,
                    left: 0,
                    width: 320,
                    borderBottomRightRadius: "6px",
                    borderBottomLeftRadius: "6px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderBottom: `1px solid ${BLACK.B_10}`,
                    borderLeft: `1px solid ${BLACK.B_10}`,
                    borderRight: `1px solid ${BLACK.B_10}`,
                    backgroundColor: WHITE.W_100,
                  }}
                >
                  <div
                    style={{
                      width: 302,
                      flex: 1,
                      paddingTop: 16,
                      borderTop: `1px solid ${BLACK.B_10}`,
                      maxHeight: 200,
                      overflow: "auto",
                    }}
                  >
                    {searchFileArray?.map((t) => {
                      return (
                        <div
                          key={t.targeting}
                          onClick={() => selectSearchName(t.targeting)}
                          style={{
                            cursor: "pointer",
                            marginBottom: 16,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            height: 26,
                          }}
                        >
                          <div
                            style={{
                              height: 20,
                              fontSize: 14,
                              fontWeight: 400,
                              color: BLACK.B_100,
                            }}
                          >
                            {t.targeting}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            <Button
              sx={{
                height: 40,
                width: 120,
                fontSize: 14,
                fontWeight: 500,
                backgroundColor: PRIMARY.P_BLue,
                lineHeight: "20px",
                marginLeft: "12px",
                borderRadius: 8,
              }}
              onClick={onSearchButtonClick}
            >
              Search
            </Button>
          </div>

          <div
            className="flex h-10 px-4 py-2 justify-center gap-2 rounded-[8px] cursor-pointer"
            style={{ border: `1px solid ${BLACK.B_5}` }}
            onClick={onFilterHandler}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10ZM18.125 5.625H1.875C1.70924 5.625 1.55027 5.69085 1.43306 5.80806C1.31585 5.92527 1.25 6.08424 1.25 6.25C1.25 6.41576 1.31585 6.57473 1.43306 6.69194C1.55027 6.80915 1.70924 6.875 1.875 6.875H18.125C18.2908 6.875 18.4497 6.80915 18.5669 6.69194C18.6842 6.57473 18.75 6.41576 18.75 6.25C18.75 6.08424 18.6842 5.92527 18.5669 5.80806C18.4497 5.69085 18.2908 5.625 18.125 5.625ZM11.875 13.125H8.125C7.95924 13.125 7.80027 13.1908 7.68306 13.3081C7.56585 13.4253 7.5 13.5842 7.5 13.75C7.5 13.9158 7.56585 14.0747 7.68306 14.1919C7.80027 14.3092 7.95924 14.375 8.125 14.375H11.875C12.0408 14.375 12.1997 14.3092 12.3169 14.1919C12.4342 14.0747 12.5 13.9158 12.5 13.75C12.5 13.5842 12.4342 13.4253 12.3169 13.3081C12.1997 13.1908 12.0408 13.125 11.875 13.125Z"
                fill="#1C1C1C"
              />
            </svg>
            <div
              style={{
                fontSize: "14px",
                fontWeight: 500,
                lineHeight: "20px",
                color: BLACK.B_100,
              }}
            >
              Filter
            </div>
          </div>
        </div>

        <div
          className="mt-6"
          style={{
            height: "calc(100vh - 376px)",
            borderRadius: 12,
            boxShadow: "0px 4px 10px 4px rgba(130, 130, 130, 0.05",
          }}
        >
          <div
            className="flex items-center w-full"
            style={{
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              height: 56,
              fontSize: 14,
              fontWeight: 700,
              lineHeight: "20px",
              backgroundColor: PRIMARY.P_Purple50,
            }}
          >
            <div className="p-4" style={{ width: "72.80%" }}>
              Keyword
            </div>
            <div className="p-4" style={{ width: "18.38%" }}>
              Keyword Type
            </div>
            <div className="p-4" style={{ width: "8.82%" }}>
              Archive
            </div>
          </div>

          {dataFetchingState === "LOADING" && (
            <div
              className="flex justify-center items-center"
              style={{
                // position: "absolute",
                height: "calc(100vh - 486px)",
                width: "calc(100% - 80px)",
              }}
            >
              <CircularProgress />
            </div>
          )}

          {dataFetchingState === "EMPTY" && (
            <div
              className="flex flex-col justify-center items-center py-6 self-stretch"
              style={{
                height: "calc(100vh - 486px)",
                // width: "calc(100% - 80px)",
              }}
            >
              <img height={220} width={220} className="shrink-0" src={`${process.env.PUBLIC_URL}/ic-content.png`} alt="Empty" />
              <div
                className="self-stretch"
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "400",
                  lineHeight: "24px",
                  color: "#9D9D9D",
                }}
              >
                No results found. Please choose another filter.
              </div>
            </div>
          )}

          {dataFetchingState === "SUCCESS" && (
            <div
              style={{ height: "calc(100vh - 486px)" }}
              className="overflow-y-auto"
            >
              {targeting_arr.length > 0 &&
                targeting_arr?.map((keyword) => {
                  return (
                    <div
                      className="flex items-center w-full"
                      key={keyword?.targeting_id}
                      style={{
                        height: 52,
                        borderBottom: `1px solid ${BLACK.B_5}`,
                        color: BLACK.B_80,
                      }}
                    >
                      <div
                        className="flex p-4 items-center self-stretch gap-2"
                        style={{ width: "72.80%" }}
                      >
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 400,
                            fontStyle: "normal",
                            lineHeight: "18px",
                            color: BLACK.B_80,
                          }}
                        >
                          {keyword?.targeting}
                        </div>
                      </div>

                      <div
                        className="flex p-4 items-center self-stretch gap-2"
                        style={{ width: "18.38%" }}
                      >
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 400,
                            fontStyle: "normal",
                            lineHeight: "18px",
                            color: BLACK.B_80,
                          }}
                        >
                          {keyword?.bcg_type}
                        </div>
                      </div>

                      <div
                        className="flex p-4 justify-center items-center gap-[4px] self-stretch cursor-pointer"
                        style={{ width: "8.82%" }}
                        onClick={() => archiveIdSave(keyword?.targeting_id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M9 7.2885C8.78717 7.2885 8.609 7.36025 8.4655 7.50375C8.32183 7.64742 8.25 7.82567 8.25 8.0385V11.7385L6.927 10.4155C6.7885 10.277 6.61442 10.2062 6.40475 10.203C6.19525 10.1997 6.018 10.2705 5.873 10.4155C5.72817 10.5603 5.65575 10.7359 5.65575 10.9423C5.65575 11.1488 5.72817 11.3244 5.873 11.4692L8.36725 13.9635C8.54808 14.1442 8.759 14.2345 9 14.2345C9.241 14.2345 9.45192 14.1442 9.63275 13.9635L12.127 11.4692C12.2653 11.3307 12.3362 11.1567 12.3395 10.947C12.3427 10.7375 12.2718 10.5603 12.127 10.4155C11.982 10.2705 11.8063 10.198 11.6 10.198C11.3937 10.198 11.218 10.2705 11.073 10.4155L9.75 11.7385V8.0385C9.75 7.82567 9.67817 7.64742 9.5345 7.50375C9.391 7.36025 9.21283 7.2885 9 7.2885ZM2 4.90375V15.6923C2 15.7821 2.02883 15.8558 2.0865 15.9135C2.14417 15.9712 2.21792 16 2.30775 16H15.6923C15.7821 16 15.8558 15.9712 15.9135 15.9135C15.9712 15.8558 16 15.7821 16 15.6923V4.90375H2ZM2.38475 17.5C1.88592 17.5 1.44708 17.3106 1.06825 16.9318C0.689417 16.5529 0.5 16.1141 0.5 15.6152V4.00575C0.5 3.79175 0.534333 3.58758 0.603 3.39325C0.6715 3.19908 0.774334 3.01992 0.9115 2.85575L2.3155 1.15775C2.4795 0.943583 2.68458 0.780416 2.93075 0.66825C3.17692 0.556083 3.43717 0.5 3.7115 0.5H14.2693C14.5436 0.5 14.8054 0.556083 15.0548 0.66825C15.3041 0.780416 15.5108 0.943583 15.675 1.15775L17.0885 2.875C17.2257 3.03917 17.3285 3.21992 17.397 3.41725C17.4657 3.61475 17.5 3.82058 17.5 4.03475V15.6152C17.5 16.1141 17.3106 16.5529 16.9318 16.9318C16.5529 17.3106 16.1141 17.5 15.6152 17.5H2.38475ZM2.3905 3.404H15.6L14.5095 2.10575C14.4775 2.07375 14.4407 2.04808 14.399 2.02875C14.3573 2.00958 14.3141 2 14.2693 2H3.72125C3.67642 2 3.63308 2.00958 3.59125 2.02875C3.54958 2.04808 3.51275 2.07375 3.48075 2.10575L2.3905 3.404Z"
                            fill="#1C1C1C"
                            fill-opacity="0.8"
                          />
                        </svg>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}

          <div
            className="flex justify-between items-center px-4"
            style={{
              borderTop: `1px solid ${BLACK.B_5}`,
              height: 60,
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 12,
            }}
          >
            <div className="flex items-center">
              <div
                className="mr-2"
                style={{ fontSize: 12, fontWeight: 400, lineHeight: "18px" }}
              >
                Rows per page:
              </div>
              <Select
                //  onChange={(e1, e2) => onSelectChangeHandler(e1, e2, "status")}
                onChange={(e, limit) =>
                  setFilterState((prevState) => ({
                    ...prevState,
                    page: 1,
                    limit: limit ? limit : 0 * 1,
                  }))
                }
                // placeholder="Select State"
                name="status"
                value={filterState.limit}
                indicator={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M9.56251 12.0625L6.54167 9.04171C6.50001 9.00004 6.46876 8.9549 6.44792 8.90629C6.42709 8.85768 6.41667 8.8056 6.41667 8.75004C6.41667 8.63893 6.45487 8.54171 6.53126 8.45837C6.60764 8.37504 6.70834 8.33337 6.83334 8.33337H13.1667C13.2917 8.33337 13.3924 8.37504 13.4688 8.45837C13.5451 8.54171 13.5833 8.63893 13.5833 8.75004C13.5833 8.77782 13.5417 8.87504 13.4583 9.04171L10.4375 12.0625C10.3681 12.132 10.2986 12.1806 10.2292 12.2084C10.1597 12.2362 10.0833 12.25 10 12.25C9.91667 12.25 9.84028 12.2362 9.77084 12.2084C9.70139 12.1806 9.63195 12.132 9.56251 12.0625Z"
                      fill="#1C1C1C"
                      fill-opacity="0.8"
                    />
                  </svg>
                }
                sx={{
                  "--Input-focusedThickness": "0px",
                  width: "80px",
                  height: "28px",
                  backgroundColor: WHITE.W_100,
                  color: BLACK.B_80,
                  fontSize: 14,
                  fontWeight: 400,
                  lineHeight: "20px",
                  border: `1px solid ${BLACK.B_10}`,
                  [`& .${selectClasses.indicator}`]: {
                    transition: "0.2s",
                    [`&.${selectClasses.expanded}`]: {
                      transform: "rotate(-180deg)",
                    },
                  },
                }}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={50}>50</Option>
              </Select>
            </div>
            {/* ---------------------Pagination Component------------------ */}
            <PaginationComponent
              page={filterState.page}
              limit={filterState.limit}
              totalRows={totalRows}
              onChange={(page) =>
                setFilterState((prevState) => ({ ...prevState, page }))
              }
            />
            {/* ---------------------Pagination Component------------------ */}
          </div>
        </div>
      </div>

      <Drawer key={"right"} anchor={"right"} open={filterToggle} size="md">
        <div
          className="flex p-6 items-start justify-between gap-10"
          style={{ height: 72, borderBottom: `1px solid ${BLACK.B_10}` }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Filters
          </div>
          <div
            className="w-fit cursor-pointer"
            onClick={() => {
              onClearFilterHandler();
              setFilterToggle(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#1C1C1C"
              />
            </svg>
          </div>
        </div>
        <DialogContent
          sx={{ paddingTop: "40px", paddingBottom: "16px", paddingX: "24px" }}
        >
          <div className="mb-6" style={{ height: 72 }}>
            <div
              className="mb-1"
              style={{
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "#5B5B5B",
              }}
            >
              Keyowrd Type
            </div>
            <MultiSelect
              children={keywordList}
              selected={selectedKeywords}
              onChange={onChangeHandler}
              placeholder="Select Keyword Type"
            />
          </div>
        </DialogContent>
        <div
          className="flex items-center justify-center gap-5 px-6"
          style={{ height: 88, borderTop: `1px solid ${BLACK.B_10}` }}
        >
          <Button
            color="neutral"
            sx={{
              height: 40,
              // width: 150,
              width:"100%",
              fontSize: 14,
              fontWeight: 500,
              backgroundColor: BLACK.B_5,
              lineHeight: "20px",
              color: BLACK.B_100,
              ":hover": {
                backgroundColor: BLACK.B_20,
              },
            }}
            onClick={()=> {
              onClearFilterHandler();
              setFilterToggle(false);
            }}
          >
            Clear Filter
          </Button>
          <Button
            // loading={lodingOnSave}
            sx={{
              height: 40,
              // width: 150,
              width:"100%",
              fontSize: 14,
              fontWeight: 500,
              backgroundColor: PRIMARY.P_BLue,
              lineHeight: "20px",
              borderRadius: 8,
            }}
            onClick={onSaveFilterHandler}
          >
            Save
          </Button>
        </div>
      </Drawer>

      <Drawer key={"right"} anchor={"right"} open={addKeywordToggle} size="md">
        <div
          className="flex p-6 items-start justify-between gap-10"
          style={{
            height: 72,
            borderBottom: `1px solid ${BLACK.B_10}`,
            backgroundColor: WHITE.W_100,
          }}
        >
          <div
            className="self-stretch"
            style={{
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              color: BLACK.B_100,
            }}
          >
            Add Keyword
          </div>

          <div
            className="w-fit cursor-pointer"
            onClick={() => { 
              setAddKeyword({targeting: "", bcg_type: ""});
              setAddKeywordToggle(false);}}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                fill="#1C1C1C"
              />
            </svg>
          </div>
        </div>
        <DialogContent
          sx={{ paddingTop: "40px", paddingBottom: "16px", paddingX: "24px" }}
        >
          <div className="mb-6" style={{ height: 76, backgroundColor: WHITE.W_100, }}>
            <div
              className="mb-1"
              style={{
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "#5B5B5B",
              }}
            >
              Keyword
            </div>
            <Input
              placeholder="Enter Keyword"
              sx={{
                "--Input-focusedThickness": "0px",
                // width: "340px",
                height: "52px",
                backgroundColor: WHITE.W_100,
                border: `1px solid ${BLACK.B_10}`,
                fontSize:"14px",
                fontWeight:"400",
                lineHeight:"20px",
                color:(addKeyword && addKeyword.targeting === "") ? BLACK.B_40 : BLACK.B_100
              }}
              value={addKeyword.targeting}
              onChange={(e)=> setAddKeyword((prev)=> ({...prev, ["targeting"]: e.target.value }))}
            />
          </div>
          <div className="mb-6" style={{ height: 76, backgroundColor: WHITE.W_100, }}>
            <div
              className="mb-1"
              style={{
                fontSize: 14,
                fontWeight: 500,
                lineHeight: "20px",
                color: "#5B5B5B",
              }}
            >
              Keyword Type
            </div>
            <Select
              placeholder="Select Keyword Type"
              className="w-full"
              onChange={bcg_typehandleDropdownChange}
              name="bcg_type"
              value={addKeyword?.bcg_type}
              indicator={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.99984 12.4791C9.88873 12.4791 9.78456 12.4618 9.68734 12.4271C9.59012 12.3923 9.49984 12.3333 9.4165 12.25L5.58317 8.41665C5.43039 8.26387 5.354 8.06942 5.354 7.83331C5.354 7.5972 5.43039 7.40276 5.58317 7.24998C5.73595 7.0972 5.93039 7.02081 6.1665 7.02081C6.40262 7.02081 6.59706 7.0972 6.74984 7.24998L9.99984 10.5L13.2498 7.24998C13.4026 7.0972 13.5971 7.02081 13.8332 7.02081C14.0693 7.02081 14.2637 7.0972 14.4165 7.24998C14.5693 7.40276 14.6457 7.5972 14.6457 7.83331C14.6457 8.06942 14.5693 8.26387 14.4165 8.41665L10.5832 12.25C10.4998 12.3333 10.4096 12.3923 10.3123 12.4271C10.2151 12.4618 10.1109 12.4791 9.99984 12.4791Z"
                    fill="#1C1C1C"
                    fill-opacity="0.4"
                  />
                </svg>
              }
              slotProps={{
                listbox: {},
              }}
              sx={{
                "--Input-focusedThickness": "0px",
                height: "52px",
                color: (addKeyword && addKeyword.bcg_type === "") ? BLACK.B_40 : BLACK.B_100,
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "20px",
                backgroundColor: WHITE.W_100,
                boxShadow: "none",
                border: `1px solid ${BLACK.B_10}`,
                [`& .${selectClasses.indicator}`]: {
                  transition: "0.2s",
                  [`&.${selectClasses.expanded}`]: {
                    transform: "rotate(-180deg)",
                  },
                },
                ":hover": {
                  backgroundColor: WHITE.W_100,
                },
              }}
            >
              <Option value={"BRAND"}>Brand</Option>
              <Option value={"COMPETITION"}>Competition</Option>
              <Option value={"GENERIC"}>Generic</Option>
            </Select>
          </div>
        </DialogContent>
        <div
          className="flex items-center justify-center gap-5 px-6"
          style={{ height: 88, borderTop: `1px solid ${BLACK.B_10}` }}
        >
          <Button
            loading={loading}
            sx={{
              height: 40,
              width: "100%",
              fontSize: 14,
              fontWeight: 500,
              backgroundColor: PRIMARY.P_BLue,
              lineHeight: "20px",
              borderRadius: 8,
            }}
            onClick={saveAddKeywordHandler}
          >
            Save
          </Button>
        </div>
      </Drawer>

      {archiveToggle && (
        <ArchiveToggle cancelArchiveHandler={cancelArchiveHandler} archiveHandler={archiveHandler} archiveloading={archiveloading}/>
      )}
    </>
  );
};

export default KeywordList;
